import React from 'react';
import { FormDialog } from '../form-dialog';
import { Container } from '../container';
import { Row } from '../row';
import { Cell } from '../cell';
import { CopyToClipboard } from '../copy-to-clipboard/copy-to-clipboard';

interface IActivationKeyDialogProps {
  activationKey: string;
  onConfirmClick: () => void;
}

export function ActivationKeyDialog(props: IActivationKeyDialogProps) {
  const { activationKey, onConfirmClick } = props;

  return (
    <FormDialog fullWidth onConfirmClick={onConfirmClick} open title="Din aktiveringsnøgle">
      <Container>
        <Row>
          <Cell size="two-thirds">{activationKey}</Cell>
          <Cell size="thirds">
            <CopyToClipboard title="Kopiér aktiveringsnøgle" toCopy={activationKey} toastText="Aktiveringsnøgle er kopieret" />
          </Cell>
        </Row>
      </Container>
    </FormDialog>
  );
}
